const apiUrl: string = process.env.VUE_APP_API;

const apiHeaders = {
  "access-control-allow-headers": "authorization",
  "access-control-allow-credentials": "true",
  "access-control-allow-origin": "*",
  "access-control-allow-methods": "GET, POST, DELETE, PUT",
  "cache-control": "no-cache, no-store, must-revalidate",
  "pragma": "no-cache",
  "expires": "Sat, 01 Jan 2000 00:00:00 GMT",
  "if-modified-since": "0",
  Accept: "application/json","Content-Type": "application/json",
};

const apiGet = async function <T>(method: string): Promise<T> {
  const response = await fetch(apiUrl + "/" + method, {
    method: "GET",
    headers: apiHeaders,
  });

  if (!response.ok) {
    throw new Error(
      "technical: " +
        response.status.toString() +
        ": " +
        (response.statusText ?? "htpp status")
    );
  }
  const result = await response.json();
  return result;
};

const apiPost = async <T>(method: string, t: T): Promise<any> => {
  console.log("apiPost: " + apiUrl + "/" + method);
  console.log("apiPost: " + t);
  console.log("apiPost: " + JSON.stringify(t));

  const response = await fetch(apiUrl + "/" + method, {
    method: "POST",

    headers: apiHeaders,
    body: JSON.stringify(t),
  });

  console.log(response);
  if (!response.ok) {
    throw new Error(
      "technical: " +
        response.status.toString() +
        ": " +
        (response.statusText ?? "htpp status")
    );
  }
  const result = await response.json();
  console.log(result);
  return result;
};

const apiPostGetPdf = async <T>(method: string, t: T): Promise<any> => {
  console.log("apiPost: " + apiUrl + "/" + method);
  console.log("apiPost: " + t);
  console.log("apiPost: " + JSON.stringify(t));

  const response = fetch(apiUrl + "/" + method, {
    method: "POST",
    headers: apiHeaders,
    body: JSON.stringify(t),
  })
    .then(async (response) => ({
      filename: "xxx.pdf",
      blob: await response.blob(),
    }))
    .then((resObj) => {
      // It is necessary to create a new blob object with mime-type explicitly set for all browsers except Chrome, but it works for Chrome too.
      const newBlob = new Blob([resObj.blob], { type: "application/pdf" });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      // eslint-disable-next-line prettier/prettier
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement("a");
        link.href = objUrl;
        // eslint-disable-next-line
        var temp: any = resObj;
        link.download = temp.filename;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => {
          window.URL.revokeObjectURL(objUrl);
        }, 250);
      }
    })
    .catch((error) => {
      console.log("DOWNLOAD ERROR", error);
    });
};

export { apiGet, apiPost, apiPostGetPdf };
